import type { FormConfig } from '../../config/types';
import type { FetchFormResponse } from '../../service/types';

export function getScsSubmissionSections(config: FormConfig, data?: FetchFormResponse) {
  const quarter = data?.scsProgress?.currentQuarter;
  if (!quarter) return [];
  return config.sections.filter((section) => section.quarterReview?.quarter === quarter);
}
